import React from "react";

export default function SectionHeader({ badge, title, isMobile = false }) {
  const badgeTextSize = isMobile ? "text-[10px]" : "text-xs";
  const badgeTracking = isMobile ? "tracking-[1px]" : "tracking-[1.2px]";
  const badgeLeading = isMobile ? "leading-[14px]" : "leading-4";
  const titleSize = isMobile ? "text-[30px]" : "text-4xl";
  const titleTracking = isMobile ? "tracking-[-0.75px]" : "tracking-[-0.9px]";
  const titleLeading = isMobile ? "leading-9" : "leading-10";

  return (
    <div className="flex flex-col gap-4 mb-6">
      {badge?.text && (
        <div className="bg-[#f2f0ff] rounded-md px-3.5 py-1.5 inline-flex items-center gap-2.5 w-fit">
          <span
            className={`text-[#1d0642] ${badgeTextSize} font-semibold uppercase ${badgeTracking} ${badgeLeading}`}
          >
            {badge.text}
          </span>
        </div>
      )}

      <div
        className={`flex ${isMobile ? "flex-col gap-2" : "items-center justify-between"}`}
      >
        <h2
          className={`text-white ${titleSize} font-medium ${titleTracking} ${titleLeading}`}
        >
          {title?.text || "What people are watching"}
        </h2>
      </div>
    </div>
  );
}
